import type { KoppelingRow } from '@fleet/shared';
import { AutoLink, PasLink } from '../../components/ui/EntiteitLink';

/**
 * Het doel van een koppelregel, als link naar de auto of de pas.
 *
 * De hele labeltekst is de link ("JND03X · Fiat Panda", "Pas 3081…"), maar de
 * bestemming komt uit `doelNaam` en `cardId` en niet uit dat label. Anders zou de
 * opmaak van die tekst de navigatie bepalen, en dan breekt een link zodra iemand
 * het label mooier maakt.
 *
 * `fontFamily: 'inherit'` omdat dit label proza bevat: een merk en model in
 * monospace leest als een serienummer.
 */
export function KoppelDoelLink({ koppeling }: { koppeling: KoppelingRow }) {
  const stijl = { fontFamily: 'inherit' } as const;
  return koppeling.doelType === 'PAS' ? (
    <PasLink pasId={koppeling.cardId} pasnummer={koppeling.label} style={stijl} />
  ) : (
    <AutoLink kenteken={koppeling.doelNaam} style={stijl}>
      {koppeling.label}
    </AutoLink>
  );
}
